import { motion } from 'motion/react';
import type { UserListItem as UserListItemType } from '@/types/admin';
import { TIER_NAMES } from '@/types/subscription';
import styles from './UserListItem.module.scss';

interface UserListItemProps {
  user: UserListItemType;
  onEdit: () => void;
}

export function UserListItem({ user, onEdit }: UserListItemProps) {
  const tierName = user.subscription?.tier ? TIER_NAMES[user.subscription.tier] : 'Foundation';
  const subscriptionStatus = user.subscription?.status || 'none';
  const isAdmin = user.permission_level.admin;

  return (
    <motion.div
      className={styles.userItem}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className={styles.userItem__main}>
        {/* User Info */}
        <div className={styles.userItem__info}>
          <div className={styles.userItem__email}>
            {user.email}
            {isAdmin && (
              <span className={styles.userItem__adminBadge}>Admin</span>
            )}
          </div>
          <div className={styles.userItem__meta}>
            Joined {new Date(user.created_at).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </div>
        </div>

        {/* Subscription Info */}
        <div className={styles.userItem__subscription}>
          <span className={`${styles.userItem__tierBadge} ${styles[`userItem__tierBadge--${user.subscription?.tier || 'foundation'}`]}`}>
            {tierName}
          </span>
          {subscriptionStatus !== 'none' && (
            <span className={`${styles.userItem__statusBadge} ${styles[`userItem__statusBadge--${subscriptionStatus}`]}`}>
              {subscriptionStatus}
            </span>
          )}
        </div>

        {/* Stats */}
        <div className={styles.userItem__stats}>
          <span className={styles.userItem__statLabel}>Quizzes:</span>
          <span className={styles.userItem__statValue}>{user.profile.total_saved_quizzes}</span>
        </div>

        {/* Actions */}
        <button
          onClick={onEdit}
          className={styles.userItem__editButton}
          aria-label={`Edit ${user.email}`}
        >
          Edit
        </button>
      </div>
    </motion.div>
  );
}
